module.exports = __webpack_public_path__ + "img/footer.2972d4bb.png";